import { render, staticRenderFns } from "./StandsForm.vue?vue&type=template&id=80f8d4e0&scoped=true"
import script from "./StandsForm.vue?vue&type=script&lang=js"
export * from "./StandsForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./StandsForm.vue?vue&type=style&index=1&id=80f8d4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f8d4e0",
  null
  
)

export default component.exports